import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select } from '@ngxs/store';
import { ICON } from '@core/util/icon';
import { Observable, Subject, Subscription, timer } from 'rxjs';
import { debounce, filter } from 'rxjs/operators';
import {
	MatterActivity,
	MatterActivitySelectors,
} from './matter-activity.selector';
import { TestHooks } from './matter-activity.hooks';
import { DropdownService } from '@components/top-nav-bar/top-nav-bar-button/dropdown.service';

@UntilDestroy()
@Component({
	selector: 'app-matter-activity',
	templateUrl: './matter-activity.component.html',
	styleUrls: ['./matter-activity.component.scss'],
	standalone: false,
})
export class MatterActivityComponent implements OnInit, OnDestroy {
	testHooks = TestHooks;

	private userIconDropdownSubscription: Subscription;

	@Select(MatterActivitySelectors.get)
	matterActivity$: Observable<MatterActivity>;

	@Input() icon: ICON;

	public showViewHistoryDropdown = false;
	public showUsersDropdown = false;
	private usersEventStream = new Subject<boolean>();

	public selectedUser = null;

	private isMouseInComponent = false;
	private isMouseInDropdown = false;
	private userIconDropdownId = 'matter-nav-user-icon';

	constructor(private dropdownService: DropdownService) {
		this.usersEventStream
			.pipe(
				untilDestroyed(this),
				debounce((shouldShow) => (shouldShow ? timer(0) : timer(500))),
			)
			.subscribe((x) => {
				if (!x && (this.isMouseInComponent || this.isMouseInDropdown)) {
					return;
				}

				this.showUsersDropdown = x;

				if (x && this.userIconDropdownId) {
					this.dropdownService.setActiveDropdown(this.userIconDropdownId);
				} else if (!x && this.userIconDropdownId) {
					this.dropdownService.clearActiveDropdown();
				}
			});
	}

	ngOnInit(): void {
		this.userIconDropdownSubscription = this.dropdownService.activeDropdown$
			.pipe(
				untilDestroyed(this),
				filter(
					(activeId) =>
						activeId !== null && activeId !== this.userIconDropdownId,
				),
			)
			.subscribe(() => {
				this.showUsersDropdown = false;
			});
	}

	ngOnDestroy(): void {
		if (this.userIconDropdownSubscription) {
			this.userIconDropdownSubscription.unsubscribe();
		}
	}

	showUserDetailsMouseover(user: MatterActivity) {
		if (user) {
			this.selectedUser = user;
		}
		this.usersEventStream.next(true);
	}

	showUserDetailsMouseout() {
		this.usersEventStream.next(false);
	}

	trackByViewHistory(index: number) {
		return index;
	}
}
